import React, { useRef, useEffect, useState } from "react";
import RealTimeScroll from "../RealTimeScroll";
import MoreAffordableScroll from "../MoreAffordableScroll";
import MultiFlatformScroll from "../MultiFltoformScroll";
import RideShareScroll from "../RideShareScroll";
import bgImage from "../../../assets/background-landing-color-2.png";

const RealTimeParent = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const scrollTimeout = useRef(null);

  const sections = [
    { id: 0, component: <RealTimeScroll /> },
    { id: 1, component: <MoreAffordableScroll /> },
    { id: 2, component: <MultiFlatformScroll /> },
    // { id: 3, component: <RideShareScroll /> },
  ];

  // Auto horizontal sliding
  useEffect(() => {
    if (isUserScrolling || isPaused) return;

    const interval = setInterval(() => {
      const container = scrollRef.current;
      if (!container) return;

      const nextIndex = (activeIndex + 1) % sections.length;
      container.scrollTo({
        left: nextIndex * container.clientWidth,
        behavior: "smooth",
      });

      setActiveIndex(nextIndex);
    }, 15000); // 15 seconds per slide (UX best practice: 1 second per 3 words)

    return () => clearInterval(interval);
  }, [activeIndex, isUserScrolling, isPaused, sections.length]);

  // Manual scroll detection
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      setIsUserScrolling(true);
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);

      scrollTimeout.current = setTimeout(() => {
        const index = Math.round(container.scrollLeft / container.clientWidth);
        setActiveIndex(index);
        setIsUserScrolling(false);
      }, 200);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  // Navigate to specific slide
  const goToSlide = (index) => {
    const container = scrollRef.current;
    if (!container) return;
    
    container.scrollTo({
      left: index * container.clientWidth,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  // Navigate to previous slide
  const handlePrev = () => {
    const prevIndex = activeIndex === 0 ? sections.length - 1 : activeIndex - 1;
    goToSlide(prevIndex);
  };

  // Navigate to next slide
  const handleNext = () => {
    const nextIndex = (activeIndex + 1) % sections.length;
    goToSlide(nextIndex);
  };

  return (
    <div className="relative w-full h-full"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* Horizontal scroll container */}
      <div
        ref={scrollRef}
        className="
          flex 
          snap-x snap-mandatory 
          overflow-x-auto 
          overflow-y-visible 
          w-full
        "
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>{`
          div::-webkit-scrollbar { display: none; }
        `}</style>

        {sections.map((sec) => (
          <>

          {/* For Real Time scroll */}
            {sec.id === 0 && <section
              key={sec.id}
              className="
              flex-shrink-0 
              w-full 
              snap-start 
              bg-cover bg-no-repeat
              overflow-y-auto   /* <-- MOST IMPORTANT FIX */
             mt-[10px]  xl-2xl:mt-0
            "
              style={{
                backgroundImage: `url(${bgImage})`,
                backgroundPosition: "center bottom",
                backgroundSize: "100% 120%",
              }}
            >
              <div className="w-full h-auto ">
                {sec.component}
              </div>
            </section>

            }

            {/* For More Affordabel scroll */}
            {sec.id === 1 && <section
              key={sec.id}
              className="
              flex-shrink-0 
              w-full 
              snap-start 
              bg-cover bg-no-repeat
              overflow-y-auto   /* <-- MOST IMPORTANT FIX */
             mt-16  xl-2xl:mt-16
            "
              style={{
                backgroundImage: `url(${bgImage})`,
                backgroundPosition: "center bottom",
                backgroundSize: "100% 120%",
              }}
            >
              <div className="w-full h-auto ">
                {sec.component}
              </div>
            </section>

            }

            {/* For Real Time scroll */}
            {sec.id === 2 && <section
              key={sec.id}
              className="
              flex-shrink-0 
              w-full 
              snap-start 
              bg-cover bg-no-repeat
              overflow-y-auto   /* <-- MOST IMPORTANT FIX */
             mt-0  xl-2xl:mt-16
            "
              style={{
                backgroundImage: `url(${bgImage})`,
                backgroundPosition: "center bottom",
                backgroundSize: "100% 120%",
              }}
            >
              <div className="w-full h-auto ">
                {sec.component}
              </div>
            </section>

            }

            {/* For More Affordabel scroll */}
            {sec.id === 3 && <section
              key={sec.id}
              className="
              flex-shrink-0 
              w-full 
              snap-start 
              bg-cover bg-no-repeat
              overflow-y-auto   /* <-- MOST IMPORTANT FIX */
             mt-16  xl-2xl:mt-16
            "
              style={{
                backgroundImage: `url(${bgImage})`,
                backgroundPosition: "center bottom",
                backgroundSize: "100% 120%",
              }}
            >
              <div className="w-full h-auto ">
                {sec.component}
              </div>
            </section>

            }
          </>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={handlePrev}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white rounded-full p-3 sm:p-4 backdrop-blur-sm transition-all duration-300 z-10 group"
        aria-label="Previous slide"
      >
        <svg 
          className="w-5 h-5 sm:w-6 sm:h-6" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <button
        onClick={handleNext}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white rounded-full p-3 sm:p-4 backdrop-blur-sm transition-all duration-300 z-10 group"
        aria-label="Next slide"
      >
        <svg 
          className="w-5 h-5 sm:w-6 sm:h-6" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-3">
        {sections.map((_, i) => (
          <button
            key={i}
            onClick={() => goToSlide(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${activeIndex === i
                ? "bg-[#FCBA05] scale-110 w-[20px]"
                : "bg-white hover:bg-white/80"
              }`}
            aria-label={`Go to slide ${i + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default RealTimeParent;
